export const addOrRemoveItemInArray = <T>(array: T[], item: T) => {
  const index = array.indexOf(item)
  if (index > 0) {
    return [
      ...array.slice(0, index),
      ...array.slice(index + 1),
    ]
  } else if (index === 0) {
    return [...array.slice(1)]
  } else {
    return [...array, item]
  }
}
